(function () {
  "use strict";

  /* ========================= INFINITE SLIDER ========================= */

  var dataEl = document.getElementById("szk-slider-data");
  var images = [];
  try {
    images = dataEl ? JSON.parse(dataEl.textContent) : [];
  } catch (e) {
    images = [];
  }

  var slider = document.querySelector(".szk-slider");

  if (slider && images.length > 0) {
    var config = {
      totalSlides: images.length,
      lerp: 0.075,
      scrollSpeed: 3.5,
      minSize: 0.1,
      growth: 0.25,
      aspect: 9 / 16,
      baseline: 0.0,
    };

    var isMobileSlider = window.matchMedia("(max-width: 700px)").matches;

    if (isMobileSlider) {
      var track = document.createElement("div");
      track.className = "szk-slider-track";

      for (var i = 0; i < images.length; i++) {
        var slide = document.createElement("div");
        slide.className = "szk-slide";

        var img = document.createElement("img");
        img.src = images[i];
        img.alt = "Slide " + (i + 1);
        img.loading = "lazy";
        slide.appendChild(img);
        track.appendChild(slide);
      }

      slider.appendChild(track);
    } else {
      var growthRatio = Math.exp(config.growth);
      var maxSliderScroll = config.totalSlides;

      var slideCount =
        Math.ceil(
          Math.log(1 + (growthRatio - 1) / config.minSize) / config.growth
        ) + 4;

      var lerp = function (start, end, t) {
        return start + (end - start) * t;
      };
      var wrap = function (value, max) {
        return ((value % max) + max) % max;
      };
      var edgeX = function (position, width) {
        return (
          (width *
            config.minSize *
            (Math.pow(growthRatio, position) - 1)) /
          (growthRatio - 1)
        );
      };

      var slides = [];
      var slideStreamIndex = [];

      for (var j = 0; j < slideCount; j++) {
        var slideEl = document.createElement("div");
        slideEl.className = "szk-slide";
        slideEl.appendChild(document.createElement("img"));
        slider.appendChild(slideEl);

        slides.push(slideEl);
        slideStreamIndex.push(j);
      }

      function setSlideImage(slide, imageIndex) {
        var idx = String(imageIndex);
        if (slide.dataset.image === idx) return;
        slide.dataset.image = idx;
        var imgEl = slide.querySelector("img");
        imgEl.src = images[imageIndex];
        imgEl.alt = "Slide " + (imageIndex + 1);
      }

      var scroll = 0;
      var scrollTarget = 0;

      slider.addEventListener(
        "wheel",
        function (e) {
          var delta = e.deltaY + e.deltaX;
          var isScrollingInsideSlider =
            (delta > 0 && scrollTarget < maxSliderScroll) ||
            (delta < 0 && scrollTarget > 0);

          if (!isScrollingInsideSlider) return;

          e.preventDefault();
          scrollTarget = Math.min(
            maxSliderScroll,
            Math.max(
              0,
              scrollTarget + delta * config.scrollSpeed * 0.0014
            )
          );
        },
        { passive: false }
      );

      var lastTouchX = null;

      slider.addEventListener("touchstart", function (e) {
        lastTouchX = e.touches[0].clientX;
      });

      slider.addEventListener(
        "touchmove",
        function (e) {
          if (lastTouchX === null) return;
          var x = e.touches[0].clientX;
          scrollTarget +=
            (lastTouchX - x) * config.scrollSpeed * 0.004;
          lastTouchX = x;
        },
        { passive: true }
      );

      slider.addEventListener("touchend", function () {
        lastTouchX = null;
      });

      var lastPointerX = null;

      slider.addEventListener("pointerdown", function (e) {
        lastPointerX = e.clientX;
        slider.setPointerCapture(e.pointerId);
      });

      slider.addEventListener("pointermove", function (e) {
        if (lastPointerX === null) return;
        scrollTarget +=
          (lastPointerX - e.clientX) * config.scrollSpeed * -0.005;
        lastPointerX = e.clientX;
      });

      var releasePointer = function () {
        lastPointerX = null;
      };

      slider.addEventListener("pointerup", releasePointer);
      slider.addEventListener("pointercancel", releasePointer);

      function render() {
        scroll += (scrollTarget - scroll) * config.lerp;

        var sliderWidth = slider.clientWidth;
        var sliderHeight = slider.clientHeight;
        var baselineOffset = sliderHeight * config.baseline;

        for (var k = 0; k < slideCount; k++) {
          var s = slides[k];
          var streamIndex = slideStreamIndex[k];

          while (edgeX(streamIndex + scroll, sliderWidth) > sliderWidth)
            streamIndex -= slideCount;
          while (edgeX(streamIndex + scroll + 1, sliderWidth) < 0)
            streamIndex += slideCount;
          slideStreamIndex[k] = streamIndex;

          var left = Math.round(
            edgeX(streamIndex + scroll, sliderWidth)
          );
          var right = Math.round(
            edgeX(streamIndex + scroll + 1, sliderWidth)
          );
          var width = right - left;
          var height = width / config.aspect;

          setSlideImage(
            s,
            wrap(streamIndex, config.totalSlides)
          );

          s.style.width = width + "px";
          s.style.height = height + "px";
          s.style.zIndex = Math.round(right);
          s.style.transform =
            "translate(" + left + "px, " + -baselineOffset + "px)";
        }

        requestAnimationFrame(render);
      }

      render();
    }
  }

  /* ========================= THEME TOGGLE ========================= */

  var themeToggle = document.querySelector(".szk-theme-toggle");
  var homepage = document.querySelector(".szk-homepage");

  if (themeToggle && homepage) {
    themeToggle.addEventListener("click", function (e) {
      var circle = e.target.closest("[data-theme]");
      if (!circle) return;
      homepage.classList.toggle(
        "szk-dark-theme",
        circle.dataset.theme === "dark"
      );
    });
  }

  /* ========================= HERO SLIDESHOW ========================= */

  var heroSlides = document.querySelectorAll(".szk-hero-slide");
  var heroCaption = document.querySelector(".szk-hero-caption");
  var activeHeroSlide = 0;

  function updateHeroCaption() {
    if (!heroCaption || !heroSlides.length) return;
    heroCaption.textContent =
      heroSlides[activeHeroSlide].dataset.caption || "";
  }

  updateHeroCaption();

  if (heroSlides.length > 1) {
    window.setInterval(function () {
      heroSlides[activeHeroSlide].classList.remove("szk-active");
      activeHeroSlide = (activeHeroSlide + 1) % heroSlides.length;
      heroSlides[activeHeroSlide].classList.add("szk-active");
      updateHeroCaption();
    }, 5000);
  }
})();
